import {Component, OnDestroy, OnInit, Input, Injector} from '@angular/core';
import { Router } from '@angular/router';
import { EventManager } from 'src/app/core';
import { ChildrenManageComponent } from 'src/app/shared/components/children-manage.component';

@Component({
  selector: 'app-bond-list',
  templateUrl: './bond-list.component.html',
  styleUrls: ['./bond-list.component.scss']
})
export class BondListComponent extends ChildrenManageComponent implements OnInit {
  @Input() title: any;
  @Input() list?: any[];
  @Input() queryParams: any = {};
  @Input() searchParams: any = {};
  constructor(
  public injector: Injector,
    public eventManager: EventManager,
    public router: Router
  ) {
    super(injector, eventManager, router, '');
  }

  ngOnInit(): void {
  }
}
